export enum ActivityFilterEnum {
  STEPS = 'steps',
  ACTIVITY_DURATION = 'activity-duration',
}
